// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '4.5.6'
export const publishDates = {
	major: '2025-09-18T14:39:22.803Z',
	minor: '2026-03-18T11:05:13.340Z',
	patch: '2026-04-01T10:10:24.793Z',
}
